export const props = {
  // Values
  item: Object,
  value: undefined,
  text: String,
  description: String,
  badge: [Number, String],
  underline: String,
  to: String,

  // Status
  focus: Boolean,
  selected: Boolean,
  turn: Boolean,
  hoverNone: Boolean,

  // Options
  color: undefined,
  tag: {
    type: String,
    default: 'a'
  },
  size: {
    type: String,
    validator: value => [
      'compact',
      'small',
      'medium',
      'large'
    ].indexOf(value) !== -1
  },
  border: Boolean,

  // Icon
  icon: undefined,
  iconTrailing: undefined
}
